import { Component, ElementRef, ViewChild } from '@angular/core';
import anime from 'animejs/lib/anime.es.js';

import { SvgLoaderComponent } from 'app/components/ui-kit/images/svg-loader/svg-loader.component';

@Component({
  selector: 'app-ai-typing',
  standalone: true,
  imports: [SvgLoaderComponent],
  templateUrl: './ai-typing.component.html',
  styleUrl: './ai-typing.component.scss'
})
export class AiTypingComponent {
  @ViewChild('bubblesContainer', { static: true }) bubblesContainer!: ElementRef;
  private animationCycle = 0;
  private readonly MAX_CYCLES = 10;

  ngAfterViewInit() {
    const bubbles: NodeListOf<HTMLElement> = this.bubblesContainer.nativeElement.querySelectorAll('.bubble');

    const runAnimationCycle = () => {
      bubbles.forEach((bubble, index) => {
        anime({
          targets: bubble,
          translateY: [
            { value: -2, duration: 300 },
            { value: 2, duration: 300 },
          ],
          opacity: [
            { value: 0.8, duration: 300 },
            { value: 0.5, duration: 300 },
          ],
          delay: (index % 3) * 180,
          easing: 'easeInOutSine',
          direction: 'alternate',
          duration: 600,
          complete: () => {
            if (index === bubbles.length - 1) {
              this.animationCycle++;
              if (this.animationCycle >= this.MAX_CYCLES) {
                anime.remove(bubbles);
                this.animationCycle = 0;
              }
              runAnimationCycle();
            }
          },
        });
      });
    };

    runAnimationCycle();
  }

  ngOnDestroy(): void {
    anime.remove(this.bubblesContainer.nativeElement.querySelectorAll('.bubble'));
  }
  
}
